import type { Location } from 'react-router-dom'

import getLinks from './getLinks.ts'
import isActiveLink from './isActiveLink.ts'

const getCurrentLink = (location: Location, workspace?: string) => {
  const links = getLinks(undefined, workspace)

  const existingLink = links.find((link) => {
    return isActiveLink(location, link.url, workspace)
  })

  const dashboardLink = links[0]

  return existingLink ?? dashboardLink
}

export default getCurrentLink
